module.exports = __webpack_public_path__ + "static/media/img8.281f0d93.jpg";